// @ts-nocheck
import { IconOffset } from "@toolkit/Framework/Types/Icon";
import * as React from "react";

const AlertCircleLine: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                fill="currentColor"
                d="M12 2l.28.004C17.673 2.152 22 6.57 22 12l-.004.28C21.848 17.673 17.43 22 12 22 6.477 22 2 17.523 2 12S6.477 2 12 2zm0 2a8 8 0 100 16l.25-.004A8 8 0 0020 12l-.004-.25A8 8 0 0012 4zm.707 11.293a1 1 0 11-1.414 1.414 1 1 0 011.414-1.414zM12 7l.117.007A1 1 0 0113 8v5a1 1 0 11-2 0V8l.007-.117A1 1 0 0112 7z"
            />
        </svg>
    );
};

export const AlertCircleLineOffset: IconOffset = {
    vertical: 8,
    horizontal: 8,
};

export default React.memo(AlertCircleLine);
